var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "otherHanfleList" },
    [
      _vm.actived == 1 || _vm.actived == 5
        ? _c(
            "div",
            {
              staticClass: "search-content",
              staticStyle: { "margin-top": "16px" },
            },
            [
              _c(
                "div",
                { staticClass: "mainBtn" },
                [
                  _vm.hasBtnPermission("online_complaints_btn_add")
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.add },
                        },
                        [_vm._v("新增")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.actived != 1 || _vm.actived != 5
        ? _c("div", {
            style: `${
              _vm.actived == 1 || _vm.actived == 5
                ? ""
                : "width:100%;height:10px;background-color:#fff;margin-top:16px;"
            }`,
          })
        : _vm._e(),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dataListLoading,
              expression: "dataListLoading",
            },
          ],
          ref: "othertableRef",
          staticClass: "table-content",
          attrs: {
            data: _vm.tableData,
            height: _vm.tableHeight,
            "header-cell-style": this.$globalGrayTableHeaderStyle,
            stripe: "",
            border: "",
          },
          on: { "sort-change": _vm.sortChange },
        },
        [
          _c("el-table-column", {
            key: 1,
            attrs: {
              index: _vm.indexMethod,
              align: "center",
              label: "序号",
              type: "index",
              width: "50",
              "show-overflow-tooltip": true,
              fixed: "left",
            },
          }),
          _vm.activedTab != "processed"
            ? _c("el-table-column", {
                key: 2,
                attrs: {
                  prop: "receiveStatusName",
                  "header-align": "left",
                  align: "left",
                  "min-width": "150",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover-${scope.$index}`,
                              attrs: {
                                placement: "bottom",
                                width: "200",
                                trigger: "click",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "margin-top": "10px",
                                  },
                                  style: {
                                    color:
                                      _vm.checkReceiveStatus.length > 0
                                        ? "#1890ff"
                                        : "",
                                  },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.activedTab == "pending"
                                          ? "本部门处理状态"
                                          : "受理状态"
                                      ) +
                                      " "
                                  ),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../../../assets/img/shaixuan.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c("div", [
                                _c(
                                  "div",
                                  { attrs: { id: "el-checkbox-group" } },
                                  [
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        model: {
                                          value: _vm.checkReceiveStatus,
                                          callback: function ($$v) {
                                            _vm.checkReceiveStatus = $$v
                                          },
                                          expression: "checkReceiveStatus",
                                        },
                                      },
                                      _vm._l(
                                        _vm.processingStateList,
                                        function (item, index) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: index,
                                              staticClass: "check_box",
                                              attrs: { label: item.value },
                                            },
                                            [_vm._v(_vm._s(item.label))]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      margin: "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                        on: { click: _vm.getDataList },
                                      },
                                      [_vm._v("筛选")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", plain: "" },
                                        on: { click: _vm.cancelReceive },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("i", {
                            class: _vm.formatterStatusClass(
                              scope.row.receiveStatus
                            ),
                          }),
                          _c("span", [
                            _vm._v(_vm._s(scope.row.receiveStatusName)),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3245951522
                ),
              })
            : _vm._e(),
          _vm.activedTab == "processed" || _vm.activedTab == "all"
            ? _c("el-table-column", {
                key: 19,
                attrs: {
                  label: "本部门处理结果",
                  prop: "owerDeptHandleResult",
                  "header-align": "left",
                  align: "left",
                  "min-width": "140",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover-${scope.$index}`,
                              attrs: {
                                placement: "bottom",
                                width: "200",
                                trigger: "click",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "margin-top": "10px",
                                  },
                                  style: {
                                    color:
                                      _vm.checkOwerDeptHandleResult.length > 0
                                        ? "#1890ff"
                                        : "",
                                  },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _vm._v(" 本部门处理结果 "),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../../../assets/img/shaixuan.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c("div", [
                                _c(
                                  "div",
                                  { attrs: { id: "el-checkbox-group" } },
                                  [
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        model: {
                                          value: _vm.checkOwerDeptHandleResult,
                                          callback: function ($$v) {
                                            _vm.checkOwerDeptHandleResult = $$v
                                          },
                                          expression:
                                            "checkOwerDeptHandleResult",
                                        },
                                      },
                                      _vm._l(
                                        _vm.checkReceiveOptions,
                                        function (item, index) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: index,
                                              staticClass: "check_box",
                                              attrs: { label: item.code },
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      margin: "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                        on: { click: _vm.getDataList },
                                      },
                                      [_vm._v("筛选")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", plain: "" },
                                        on: {
                                          click: _vm.cancelDeptHandleResult,
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.owerDeptHandleResult
                            ? _c("i", {
                                class: _vm.formatterResultClass(
                                  scope.row.handleStatus
                                ),
                              })
                            : _vm._e(),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.owerDeptHandleResult
                                  ? scope.row.owerDeptHandleResult
                                  : "--"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  459927146
                ),
              })
            : _vm._e(),
          _vm.activedTab == "pending" ||
          _vm.activedTab == "processed" ||
          _vm.activedTab == "all"
            ? _c("el-table-column", {
                key: 3,
                attrs: {
                  label: "整体处理进度",
                  prop: "progress",
                  align: "left",
                  "min-width": "460",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.progress ? scope.row.progress : "--"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2804662243
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            key: 4,
            attrs: {
              label: "投诉编号",
              prop: "complaintCode",
              "header-align": "center",
              align: "center",
              "min-width": "150",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          trigger: "click",
                          width: "200",
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              "margin-top": "10px",
                            },
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [
                            _vm._v(" 投诉编号 "),
                            _c("i", { staticClass: "el-icon-search" }),
                          ]
                        ),
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                padding: "12px",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入投诉编号",
                                },
                                model: {
                                  value: _vm.complaintCodeSearch,
                                  callback: function ($$v) {
                                    _vm.complaintCodeSearch = $$v
                                  },
                                  expression: "complaintCodeSearch",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "10px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { plain: "", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      {
                                        _vm.complaintCodeSearch = ""
                                        _vm.getDataList()
                                      }
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.searchChoseTimefunc(
                                        _vm.complaintCodeSearch,
                                        4
                                      )
                                    },
                                  },
                                },
                                [_vm._v("搜索")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.activedTab == "waitAccept" || _vm.activedTab == "all"
            ? _c(
                "el-table-column",
                {
                  key: 5,
                  attrs: {
                    align: "center",
                    "header-align": "center",
                    label: "受理时效",
                    "min-width": "100",
                    prop: "receiveTimeliness",
                    "show-overflow-tooltip": true,
                  },
                },
                [[_vm._v("--")]],
                2
              )
            : _vm._e(),
          _vm.activedTab == "pending" ||
          _vm.activedTab == "processed" ||
          _vm.activedTab == "all"
            ? _c("el-table-column", {
                key: 6,
                attrs: {
                  align: "center",
                  "header-align": "center",
                  label: "处理时效",
                  "min-width": "100",
                  prop: "handleRateName",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover-${scope.$index}`,
                              attrs: {
                                placement: "bottom",
                                width: "200",
                                trigger: "click",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "margin-top": "10px",
                                  },
                                  style: {
                                    color:
                                      _vm.handleRateChoseList.length > 0
                                        ? "#1890ff"
                                        : "",
                                  },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _vm._v(" 处理时效 "),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../../../assets/img/shaixuan.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c("div", [
                                _c(
                                  "div",
                                  { attrs: { id: "el-checkbox-group" } },
                                  [
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        model: {
                                          value: _vm.handleRateChoseList,
                                          callback: function ($$v) {
                                            _vm.handleRateChoseList = $$v
                                          },
                                          expression: "handleRateChoseList",
                                        },
                                      },
                                      _vm._l(
                                        _vm.handleRateNameList,
                                        function (item, index) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: index,
                                              staticClass: "check_box",
                                              attrs: { label: item.value },
                                            },
                                            [_vm._v(_vm._s(item.label))]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      margin: "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                        on: { click: _vm.getDataList },
                                      },
                                      [_vm._v("筛选")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", plain: "" },
                                        on: {
                                          click: _vm.cancelHandleRateNameList,
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.handleRateName
                            ? _c(
                                "el-tag",
                                {
                                  staticStyle: {
                                    color: "#FFF",
                                    opacity: "0.6",
                                    border: "none",
                                  },
                                  attrs: {
                                    color: scope.row.handleRateColor
                                      ? scope.row.handleRateColor
                                      : "#1890FF",
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.handleRateName))]
                              )
                            : _c("span", [_vm._v("--")]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3294469174
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            key: 7,
            attrs: {
              label: "项目(标段)名称",
              prop: "bidSectionName",
              "header-align": "left",
              "min-width": "200",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          trigger: "click",
                          width: "220",
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              "margin-top": "10px",
                            },
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [
                            _vm._v(" 项目(标段)名称 "),
                            _c("i", { staticClass: "el-icon-search" }),
                          ]
                        ),
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                padding: "12px",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入项目(标段)名称",
                                },
                                model: {
                                  value: _vm.bidSectionNameSearch,
                                  callback: function ($$v) {
                                    _vm.bidSectionNameSearch = $$v
                                  },
                                  expression: "bidSectionNameSearch",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "10px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { plain: "", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      {
                                        _vm.bidSectionNameSearch = ""
                                        _vm.getDataList()
                                      }
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.searchChoseTimefunc(
                                        _vm.bidSectionNameSearch,
                                        6
                                      )
                                    },
                                  },
                                },
                                [_vm._v("搜索")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            key: 8,
            attrs: {
              label: "项目(标段)编号",
              prop: "bidSectionCode",
              align: "center",
              "header-align": "center",
              "min-width": "230",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          trigger: "click",
                          width: "220",
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              "margin-top": "10px",
                            },
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [
                            _vm._v(" 项目(标段)编号 "),
                            _c("i", { staticClass: "el-icon-search" }),
                          ]
                        ),
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                padding: "12px",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入项目(标段)编号",
                                },
                                model: {
                                  value: _vm.bidSectionCodeSearch,
                                  callback: function ($$v) {
                                    _vm.bidSectionCodeSearch = $$v
                                  },
                                  expression: "bidSectionCodeSearch",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "10px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { plain: "", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      {
                                        _vm.bidSectionCodeSearch = ""
                                        _vm.getDataList()
                                      }
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.searchChoseTimefunc(
                                        _vm.bidSectionCodeSearch,
                                        7
                                      )
                                    },
                                  },
                                },
                                [_vm._v("搜索")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            key: 20,
            attrs: {
              label: "投诉人员",
              prop: "complainter",
              align: "center",
              "header-align": "center",
              "min-width": "120",
              "show-overflow-tooltip": true,
            },
          }),
          _vm.activedTab == "all"
            ? _c("el-table-column", {
                key: 21,
                attrs: {
                  label: "投诉单位",
                  prop: "complainterUnit",
                  align: "center",
                  "header-align": "center",
                  "min-width": "120",
                  "show-overflow-tooltip": true,
                },
              })
            : _vm._e(),
          _vm.activedTab == "all"
            ? _c("el-table-column", {
                key: 9,
                attrs: {
                  label: "被投诉单位",
                  prop: "appelleeUnits",
                  align: "center",
                  "header-align": "center",
                  "min-width": "120",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.appelleeUnits
                                  ? scope.row.appelleeUnits
                                  : "--"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  62673443
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            key: 10,
            attrs: {
              label: "投诉提交时间",
              prop: "submitTime",
              align: "center",
              "header-align": "center",
              "min-width": "180",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          trigger: "click",
                          width: "300",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              "margin-top": "10px",
                            },
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [
                            _vm._v(" 投诉提交时间 "),
                            _c("i", { staticClass: "el-icon-search" }),
                          ]
                        ),
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                padding: "12px",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "daterange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  format: "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.submitTimeValue,
                                  callback: function ($$v) {
                                    _vm.submitTimeValue = $$v
                                  },
                                  expression: "submitTimeValue",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "10px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { plain: "", size: "mini" },
                                  on: {
                                    click: () => {
                                      _vm.submitTimeValue = []
                                      _vm.submitTimeLE = ""
                                      _vm.submitTimeGE = ""
                                      _vm.getDataList()
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.searchChoseTimefunc(
                                        _vm.submitTimeValue,
                                        1
                                      )
                                    },
                                  },
                                },
                                [_vm._v("搜索")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            key: 11,
            attrs: {
              label: "投诉受理部门",
              prop: "receiveOrgName",
              "min-width": "160",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          trigger: "click",
                          width: "220",
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              "margin-top": "10px",
                            },
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [
                            _vm._v(" 投诉受理部门 "),
                            _c("i", { staticClass: "el-icon-search" }),
                          ]
                        ),
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                padding: "12px",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入投诉受理部门",
                                },
                                model: {
                                  value: _vm.receiveOrgNameSearch,
                                  callback: function ($$v) {
                                    _vm.receiveOrgNameSearch = $$v
                                  },
                                  expression: "receiveOrgNameSearch",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "10px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { plain: "", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      {
                                        _vm.receiveOrgNameSearch = ""
                                        _vm.getDataList()
                                      }
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.searchChoseTimefunc(
                                        _vm.receiveOrgNameSearch,
                                        5
                                      )
                                    },
                                  },
                                },
                                [_vm._v("搜索")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.activedTab == "pending" ||
          _vm.activedTab == "processed" ||
          _vm.activedTab == "all"
            ? _c("el-table-column", {
                key: 12,
                attrs: {
                  label: "投诉受理人员",
                  prop: "receiverName",
                  "header-align": "center",
                  align: "center",
                  "min-width": "120",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.receiverName
                                  ? scope.row.receiverName
                                  : "--"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1227908547
                ),
              })
            : _vm._e(),
          _vm.activedTab == "pending" ||
          _vm.activedTab == "processed" ||
          _vm.activedTab == "all"
            ? _c("el-table-column", {
                key: 13,
                attrs: {
                  label: "投诉受理时间",
                  prop: "receiveTime",
                  "header-align": "center",
                  align: "center",
                  "min-width": "160",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "bottom",
                                trigger: "click",
                                width: "300",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "margin-top": "10px",
                                  },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _vm._v(" 投诉受理时间 "),
                                  _c("i", { staticClass: "el-icon-search" }),
                                ]
                              ),
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      padding: "12px",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                      },
                                      model: {
                                        value: _vm.receiveTimeValue,
                                        callback: function ($$v) {
                                          _vm.receiveTimeValue = $$v
                                        },
                                        expression: "receiveTimeValue",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      margin: "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { plain: "", size: "mini" },
                                        on: {
                                          click: () => {
                                            _vm.receiveTimeValue = []
                                            _vm.receiveTimeLE = ""
                                            _vm.receiveTimeGE = ""
                                            _vm.getDataList()
                                          },
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.searchChoseTimefunc(
                                              _vm.receiveTimeValue,
                                              2
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("搜索")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.receiveTime
                                  ? scope.row.receiveTime
                                  : "--"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3745859913
                ),
              })
            : _vm._e(),
          _vm.activedTab == "processed" || _vm.activedTab == "all"
            ? _c("el-table-column", {
                key: 14,
                attrs: {
                  label: "处理完成时间",
                  fixed: "right",
                  prop: "handleTime",
                  "header-align": "center",
                  align: "center",
                  "min-width": "160",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "bottom",
                                trigger: "click",
                                width: "300",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "margin-top": "10px",
                                  },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _vm._v(" 处理完成时间 "),
                                  _c("i", { staticClass: "el-icon-search" }),
                                ]
                              ),
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      padding: "12px",
                                    },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                      },
                                      model: {
                                        value: _vm.handleTimeValue,
                                        callback: function ($$v) {
                                          _vm.handleTimeValue = $$v
                                        },
                                        expression: "handleTimeValue",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      margin: "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { plain: "", size: "mini" },
                                        on: {
                                          click: () => {
                                            _vm.handleTimeValue = []
                                            _vm.handleTimeLE = ""
                                            _vm.handleTimeGE = ""
                                            _vm.getDataList()
                                          },
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.searchChoseTimefunc(
                                              _vm.handleTimeValue,
                                              3
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("搜索")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.handleTime
                                  ? scope.row.handleTime
                                  : "--"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  677294266
                ),
              })
            : _vm._e(),
          _vm.activedTab == "processed" || _vm.activedTab == "all"
            ? _c("el-table-column", {
                key: 15,
                attrs: {
                  label: "办结状态",
                  fixed: "right",
                  prop: "endStatusName",
                  "header-align": "center",
                  align: "center",
                  "min-width": "110",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover-${scope.$index}`,
                              attrs: {
                                placement: "bottom",
                                width: "200",
                                trigger: "click",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "margin-top": "10px",
                                  },
                                  style: {
                                    color:
                                      _vm.checkEndStatus.length > 0
                                        ? "#1890ff"
                                        : "",
                                  },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _vm._v(" 办结状态 "),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../../../assets/img/shaixuan.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c("div", [
                                _c(
                                  "div",
                                  { attrs: { id: "el-checkbox-group" } },
                                  [
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        model: {
                                          value: _vm.checkEndStatus,
                                          callback: function ($$v) {
                                            _vm.checkEndStatus = $$v
                                          },
                                          expression: "checkEndStatus",
                                        },
                                      },
                                      _vm._l(
                                        _vm.checkEndStatusOptions,
                                        function (item, index) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: index,
                                              staticClass: "check_box",
                                              attrs: { label: item.code },
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      margin: "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                        on: { click: _vm.getDataList },
                                      },
                                      [_vm._v("筛选")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", plain: "" },
                                        on: { click: _vm.cancelCheckEndStatus },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.findType(scope.row.endStatus),
                              },
                            },
                            [_vm._v(_vm._s(scope.row.endStatusName))]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2408127650
                ),
              })
            : _vm._e(),
          _vm.activedTab == "processed" || _vm.activedTab == "all"
            ? _c("el-table-column", {
                key: 16,
                attrs: {
                  label: "最终处理结果",
                  fixed: "right",
                  prop: "lastHandleStatusName",
                  align: "center",
                  "min-width": "130",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover-${scope.$index}`,
                              attrs: {
                                placement: "bottom",
                                width: "200",
                                trigger: "click",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "margin-top": "10px",
                                  },
                                  style: {
                                    color:
                                      _vm.checkLastHandleStatus.length > 0
                                        ? "#1890ff"
                                        : "",
                                  },
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                },
                                [
                                  _vm._v(" 最终处理结果 "),
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../../../assets/img/shaixuan.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                              _c("div", [
                                _c(
                                  "div",
                                  { attrs: { id: "el-checkbox-group" } },
                                  [
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        model: {
                                          value: _vm.checkLastHandleStatus,
                                          callback: function ($$v) {
                                            _vm.checkLastHandleStatus = $$v
                                          },
                                          expression: "checkLastHandleStatus",
                                        },
                                      },
                                      _vm._l(
                                        _vm.checkReceiveOptions,
                                        function (item, index) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: index,
                                              staticClass: "check_box",
                                              attrs: { label: item.code },
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-align": "right",
                                      margin: "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                        },
                                        on: { click: _vm.getDataList },
                                      },
                                      [_vm._v("筛选")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini", plain: "" },
                                        on: {
                                          click: _vm.cancelLastHandleStatus,
                                        },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                scope.row.lastHandleStatusName
                                  ? scope.row.lastHandleStatusName
                                  : "--"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  379336212
                ),
              })
            : _vm._e(),
          _c("el-table-column", {
            key: 17,
            attrs: {
              label: "异常状态",
              fixed: "right",
              prop: "revokeStatusName",
              "header-align": "center",
              align: "center",
              "min-width": "130",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "redText",
                        on: {
                          click: function ($event) {
                            return _vm.goExceptionDetail(scope.row)
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("filterRevokeStatus")(scope.row.revokeStatus)
                          )
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm.activedTab == "all"
            ? _c("el-table-column", {
                key: 22,
                attrs: {
                  label: "修改人",
                  prop: "updateUser",
                  "header-align": "center",
                  align: "center",
                  "min-width": "120",
                  "show-overflow-tooltip": true,
                },
              })
            : _vm._e(),
          _vm.activedTab == "all"
            ? _c("el-table-column", {
                key: 23,
                attrs: {
                  label: "修改时间",
                  prop: "updateTime",
                  "header-align": "center",
                  align: "center",
                  "min-width": "180",
                  sortable: "",
                  "show-overflow-tooltip": true,
                },
              })
            : _vm._e(),
          _c("el-table-column", {
            key: 18,
            attrs: {
              label: "操作",
              align: "center",
              fixed: "right",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small", title: "查看" },
                        on: {
                          click: function ($event) {
                            return _vm.getDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    scope.row.receiveStatusName == "待提交"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "small",
                              title: "删除",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deteleRow(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          background: "",
          layout: "total, prev, pager, next",
          "page-size": _vm.pageSize,
          total: _vm.total,
          "current-page": _vm.pageIndex,
        },
        on: {
          "size-change": _vm.sizeChangeHandle,
          "current-change": _vm.currentChangeHandle,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }